import React from 'react'
import styled from "styled-components"

import { Link as InternalLink } from "gatsby"

import { typeHeading02, typeHeading04, typeBody01, typeBody02, typeBody03, typeLabel01 } from '../../theme/typography'
import { grid, row, column } from '../../theme/grid'
import { gutter, spacer, unit, pixelate, margin, SIZE, mediaQuery } from '../../theme/metrics'
import { WHITE_01, GREY_01 } from '../../theme/colors'

import { StyledButton } from '../../theme/components';


export const Inner = styled.div`
	${props => row({medium:true})}
`

export const ContentContainer = styled.div`
	${props => column({medium:{span:5,after:1}},{direction:props.theme.direction})}
	position: relative;
	&:before{
		content: url(/images/squiggle-2.svg);
		width:176px;
		height:176px;
		position: absolute;
		display: block;
		top: 0;
		left: 0;
		transform: translate(0,-25%);
	}
`

export const ContentInner = styled.div`
	position: relative;
`

export const Heading = styled.div`
	${typeHeading02}
	color: ${props => props.theme.foreground};
	margin-bottom: ${unit(3)};
`

export const Text = styled.div`
	${typeBody02}
	color: ${props => props.theme.foreground};

	p{
		margin-bottom: ${unit(3)};

		&:last-child{
			margin-bottom: 0;
		}
	}
	
	em{
		background-color: ${props => props.theme.highlight};
	}

	a{
		color: ${props => props.theme.foreground};
		transition: opacity 0.3s;

		&:hover{
			opacity: 0.6;
		}
	}

	margin-bottom: ${spacer(1)};
`

export const ImageContainer = styled.div`
	${props => column({medium:{span:6}},{direction:props.theme.direction})}

`

export const ImageInner = styled.div`
	flex: 1;
	position: relative;
	margin-top: ${margin(SIZE.small)};

	${mediaQuery[SIZE.medium]}{
		margin-top: 0;
	}

	&:before{
		content: "";
		width: 100%;
		height: 100%;
		position: absolute;
		background-color: ${WHITE_01};
		top: ${margin(SIZE.small, {multiplier:-1})};
		left: ${margin(SIZE.small, {multiplier:-1})};

		${mediaQuery[SIZE.medium]}{
			top: ${gutter(SIZE.medium, {multiplier:-1})};
			left: ${gutter(SIZE.medium, {multiplier:-1})};
		}

		${mediaQuery[SIZE.large]}{
			top: ${gutter(SIZE.large, {multiplier:-1})};
			left: ${gutter(SIZE.large, {multiplier:-1})};
		}

		${mediaQuery[SIZE.max]}{
			top: ${gutter(SIZE.max, {multiplier:-1})};
			left: ${gutter(SIZE.max, {multiplier:-1})};
		}
	}
`

export const Image = styled.img`
	width: 100%;
	height: auto;
	position: relative;
`

export const Article = styled.div`
	margin-bottom: ${spacer(1)};
	display: block;
	text-decoration: none;
	transition: opacity 0.3s;

	&:hover{
		opacity: 0.6;
	}

	${mediaQuery[SIZE.medium]}{
		&:last-child{
			margin-bottom: 0;
		}
	}
`

export const Category = styled.p`
	${typeLabel01}
	color: ${props => props.theme.foreground};
	margin-bottom: ${unit(2)};
`

export const Summary = styled.p`
	${typeHeading04}
	color: ${props => props.theme.foreground};
	margin-bottom: ${unit(2)};
`

export const Published = styled.p`
	${typeBody03}
	color: ${props => props.theme.foreground};
`

export const Button = styled(StyledButton)`
	margin-bottom: ${spacer(1)};

	${mediaQuery[SIZE.medium]}{
		margin-bottom: 0;
	}
`